.page { display: flex; flex-direction: column; gap: 16px; padding-top: 5px; padding-bottom: 32px; min-width: 0; }
.split { position: relative; display: grid; grid-template-columns: minmax(0, 1fr); gap: 16px; align-items: start; }
.split.withDock { grid-template-columns: minmax(0, 1fr) 372px; }
.tabsPhone { display: none; overflow-x: auto; max-width: 100%; }
.col { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.bar { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; min-height: 44px; }
.search { flex: 1 1 220px; min-width: 0; max-width: 300px; }
.chips { display: flex; flex-wrap: wrap; gap: 8px; }
.chipBtn { height: 34px; padding: 0 12px; border-radius: 10px; border: 0; background: var(--ctl); color: var(--tx2); font: inherit; font-weight: var(--fw-label); cursor: pointer; }
.chipBtn[aria-pressed='true'] { background: var(--pri-bg); color: var(--link); }
.chipBtn:focus-visible, .title:focus-visible, .dockRow2:focus-visible { outline: 2px solid var(--pri); outline-offset: 1px; }
.count { margin-left: auto; color: var(--tx2); white-space: nowrap; }
.list { display: flex; flex-direction: column; background: var(--card); border-radius: 16px; box-shadow: var(--sh); overflow: hidden; }
.row { line-height: 1.4; display: flex; align-items: flex-start; gap: 14px; padding: 14px 18px; border-bottom: 1px solid var(--line); }
.row:last-child { border-bottom: 0; }
.dot { width: 8px; height: 8px; margin-top: 7px; border-radius: 50%; background: var(--pri); flex: none; }
.dot.read { background: transparent; border: 1.5px solid var(--bd); box-sizing: border-box; }
.main { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.title { text-align: left; border: 0; background: transparent; padding: 0; font: inherit; font-size: 14px; font-weight: var(--fw-title); color: var(--tx); cursor: pointer; }
.sum { color: var(--tx2); font-size: 13px; margin-top: 3px; }
.meta { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-top: 6px; color: var(--lb); font-size: 12px; }
.tag { padding: 1px 7px; border-radius: 6px; background: var(--sub); color: var(--tx2); font-weight: var(--fw-label); }
.meta b { color: var(--tx2); font-weight: var(--fw-label); }
.meta span { display: inline-flex; align-items: center; gap: 3px; }
.sub { font-size: 12.5px; color: var(--lb); }
.inline { display: inline-flex; align-items: center; gap: 6px; }
.card { background: var(--card); border: 1px solid var(--bd); border-radius: 16px; box-shadow: var(--sh); padding: 8px; min-width: 0; }
.cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; }
.idx { display: flex; flex-direction: column; gap: 8px; padding: 14px 16px; border: 1px solid var(--bd); border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.idxHead { display: flex; align-items: baseline; justify-content: space-between; }
.idxHead b { font-size: 15px; font-weight: var(--fw-title); }
.idxVal { display: flex; align-items: baseline; gap: 10px; }
.idxVal b { font-size: 24px; font-weight: var(--fw-title); font-variant-numeric: tabular-nums; }
.up { color: var(--warn); font-size: 13px; }
.down { color: var(--err); font-size: 13px; }
.spark { color: var(--pri); }
.dock { display: flex; flex-direction: column; gap: 8px; padding: 14px 16px; border: 1px solid var(--bd); border-radius: 16px; background: var(--card); box-shadow: var(--sh); font-size: 13px; }
.dock > b { font-weight: var(--fw-title); font-size: 14px; }
.dock hr { border: 0; border-top: 1px solid var(--line); margin: 4px 0; width: 100%; }
.dockRow { display: flex; align-items: center; gap: 10px; min-height: 44px; border-top: 1px solid var(--line); font-variant-numeric: tabular-nums; }
.dockRow > b { width: 52px; font-weight: var(--fw-title); }
.dockVal { margin-left: auto; font-weight: var(--fw-label); }
.dockUp, .dockDown { width: 56px; text-align: right; font-weight: var(--fw-label); }
.dockUp { color: var(--err); }
.dockDown { color: var(--ok); }
.sparkUp { color: var(--warn); }
.dockRow2 { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; padding: 8px 0; border: 0; border-top: 1px solid var(--line); border-radius: 0; background: transparent; color: var(--tx); font: inherit; text-align: left; cursor: pointer; }
.dockRow2:first-of-type { border-top: 0; }
.dockRow2 b { font-weight: var(--fw-label); }
.dockRow2 span { color: var(--warn); font-size: 12px; font-weight: var(--fw-label); }
.note { padding: 10px 14px; border-radius: 12px; background: var(--sub); color: var(--lb); font-size: 13px; }
.url { font-size: 12.5px; color: var(--lb); word-break: break-all; }
.url em { font-style: normal; color: var(--tx2); }
.reader { display: flex; flex-direction: column; gap: 14px; }
.reader h3 { margin: 0 0 6px; font-size: 13px; font-weight: var(--fw-label); color: var(--lb); }
.reader p { margin: 0; font-size: 15px; line-height: 1.5; color: var(--tx); }
.tags { display: flex; flex-wrap: wrap; gap: 6px; }
@media (max-width: 767px) { .tabsPhone { display: block; } }
@media (max-width: 767px) { .page { padding-bottom: 24px; } .count { margin-left: 0; } }
.n { color: var(--lb); font-size: 12px; font-weight: 400; margin-left: 6px; }
.tick { display: inline-flex; align-items: center; gap: 6px; margin-left: 6px; flex-shrink: 0; color: var(--tx2); cursor: pointer; white-space: nowrap; }
.tick input { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); }
.acts { display: flex; align-items: flex-start; gap: 6px; flex: none; }
.foot { padding: 14px 16px; color: var(--lb); font-size: 13px; border-top: 1px solid var(--line); }
.float { position: absolute; top: 0; right: 0; z-index: 5; width: 372px; border-radius: 18px; box-shadow: var(--pop); }
.dockX { position: absolute; top: 8px; right: 8px; }
.dock { position: relative; }

/* Ngăn Thêm / Sửa nguồn feed */
.dwBody { display: flex; flex-direction: column; gap: 14px; }
.dwFields { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 14px; }
.dwWide { grid-column: span 2; }
.dwKind { display: flex; align-items: center; gap: 10px; }
.dwKind b, .dwTestHead b { font-weight: 550; }
.dwOn { display: flex; align-items: center; gap: 10px; cursor: pointer; }
.dwTest { display: flex; flex-direction: column; gap: 6px; padding: 12px 14px; border-radius: 12px; border: 1px solid var(--line); font-size: 12px; }
.dwTestHead { display: flex; align-items: center; gap: 6px; }
.dwTestHead b { flex-grow: 1; font-size: 14px; }
.dwFoot { display: flex; align-items: center; gap: 8px; width: 100%; }
.dwGrow { flex-grow: 1; }

/* Công tắc Bật nguồn (board: 40×24, núm 18) */
.sw { position: relative; width: 40px; height: 24px; border: 0; border-radius: 12px; background: var(--bd); cursor: pointer; padding: 0; }
.sw span { position: absolute; top: 3px; left: 3px; width: 18px; height: 18px; border-radius: 50%; background: var(--card); box-shadow: var(--sh); }
.swOn { background: var(--pri); }
.swOn span { left: 19px; }

.routeBox { margin-top: 12px; border: 1px solid var(--bd); border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow: clip; }
.routeHead { display: flex; align-items: center; gap: 12px; padding: 14px 16px; border-bottom: 1px solid var(--line); }
.routeHead h2 { margin: 0; font-size: 16px; font-weight: var(--fw-title); }
.routeHead .sub { margin-left: auto; }
.routeRow { display: grid; grid-template-columns: 1.6fr 0.8fr 0.8fr 0.8fr 1fr; gap: 10px; min-height: 44px; align-items: center; padding: 0 16px; border-bottom: 1px solid var(--line); font-variant-numeric: tabular-nums; }
.routeTh { min-height: 38px; font-size: 12px; font-weight: 500; color: var(--lb); }
.num { text-align: right; }
